import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceFormat'
})
export class PriceFormatPipe implements PipeTransform {

  transform(price: string, priceClassName: string, suffixClassName: string): string {
    if (!price) {
      return '';
    }
    const matches = price.match(/^([A-Z\$]*)?([0-9,]*)(.[0-9]+)?(万円)?/);
    const currencyCode = matches[1] ? `<span class="currency_code">${matches[1]}</span>` : '';
    const decimalFormatted = matches[3] ? `<span class="format">${matches[3]}</span>` : '';
    const priceFormatted = `<span class="${priceClassName}">${matches[2]}${decimalFormatted}</span>`
      .replace(/(,)/g, '<span class="format">$1</span>');
    const priceSuffix = matches[4] ? `<span class="${suffixClassName}">${matches[4]}</span>` : '';
    return currencyCode + priceFormatted + priceSuffix;
  }

}
